import React from 'react';
import './components/assets/vendor/bootstrap/css/bootstrap.min.css';
import './components/assets/vendor/icofont/icofont.min.css';
import './components/assets/vendor/boxicons/css/boxicons.min.css';
import './components/assets/vendor/animate.css/animate.min.css';
import './components/assets/vendor/remixicon/remixicon.css';
import './components/assets/vendor/venobox/venobox.css';
import './components/assets/vendor/owl.carousel/assets/owl.carousel.min.css';
import './components/assets/css/style.css';
import { Route, Switch } from "react-router-dom";
import Home from './components/Home';
import About from './components/About';
import Header from './components/header';
import Footer from './components/footer';
import Errorpage from './components/Errorpage';
import Services from './components/services';
import Covidworld from './components/Covidworld';
import Blogdetails from './components/blogdetails';
import Contact from './components/Contact';
import Todo from './components/todo';
import Covidlive from './components/Covidlive';
import Statewise from './components/Statewise';
import DataApi from './components/DataApi';
import Emp from './components/Emp';
import Appdata from './components/Appdata';



const App = () => {
  return (
    <>
     <Header/>
   <Switch>
   <Route exact path="/" component={Home}/>
   <Route exact  path="/about" component={About}/>
   <Route exact  path="/services" component={Services}/>
   <Route exact  path="/Covidworld" component={Covidworld}/>
   <Route exact  path="/todo" component={Todo}/>
   <Route exact  path="/Contact" component={Contact}/>
   <Route exact path="/blogdetails" component={Blogdetails}/>
   <Route exact path="/Covidlive" component={Covidlive}/>
   <Route exact path="/Statewise" component={Statewise}/>
   <Route exact path="/DataApi" component={DataApi}/>
   <Route exact path="/Emp" component={Emp}/>
   <Route exact path="/Appdata" component={Appdata}/>
   <Route  component={Errorpage}/>
   </Switch>
   <Footer />
  
    </>
  )
}

export default App;
